import { Box, styled } from '@material-ui/core';
import { QRCodeSVG } from 'qrcode.react';

export const StoreBadgeContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 16,
  marginTop: 24,
});

export const StoreBadgeLink = styled('a')({
  display: 'inline-block',
  '& img': {
    height: 48,
  },
});

export const QRCodeWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  margin: '0 16px',
  marginTop: 24,
});

export const QRCode = styled(QRCodeSVG)({
  marginBottom: 16,
});
